import { render, staticRenderFns } from "./EventsSchedule.vue?vue&type=template&id=27fa6a34&scoped=true"
import script from "./EventsSchedule.vue?vue&type=script&lang=js"
export * from "./EventsSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa6a34",
  null
  
)

export default component.exports